/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import FormFader from "../Common/Fader/FormFader";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import FormSubmit from "../Common/FormSubmit/FormSubmit";
import CarIcon from "../../../assets/icons/traffic/toggleable/IconCar";
import BikeIcon from "../../../assets/icons/traffic/toggleable/IconBicycle";
import MotorcycleIcon from "../../../assets/icons/traffic/toggleable/IconMotorcycle";
import TruckIcon from "../../../assets/icons/traffic/toggleable/IconTruck";
import BusIcon from "../../../assets/icons/traffic/toggleable/IconBus";
import { useForm } from "../../../provider/Form/FormProvider";
import Group from "../../Wizard/Group";
import { requiredValidator } from "../../../services/validationRules";
import Typography from "@mui/material/Typography";
import { translate } from "../../../services/translations/translations";
import FormSubmitProps from "../../../types/FormSubmitProps";
import wizardStyle from "../wizardStyle";
import { Box } from "@mui/material";

export default function MobileVehicle({ submitProps }: { submitProps: FormSubmitProps }) {
  const { handleSubmit, values } = useForm();
  return (
    <Paper sx={wizardStyle.paper} elevation={4}>
      <FormFader>
        <Box component={"form"} sx={{ ...wizardStyle.applicationForm, ...wizardStyle.wizardForm }} onSubmit={handleSubmit}>
          <Typography variant={"h4"} sx={[wizardStyle.headline, { display: { xs: "block", sm: "none" } }]}>
            Verstoß
          </Typography>
          <Grid
            container
            sx={{
              justifyContent: "center",
            }}
          >
            <Grid size={12}>
              <Group
                type="radio"
                name="vehicle"
                question={translate("traffic.vehicle.label", values)}
                options={[
                  {
                    labelText: translate("traffic.vehicle.options.car.label", values),
                    labelIcon: <CarIcon />,
                    labelIconActive: <CarIcon active />,
                    value: "car",
                  },
                  {
                    labelText: translate("traffic.vehicle.options.bike.label", values),
                    labelIcon: <BikeIcon />,
                    labelIconActive: <BikeIcon active />,
                    value: "bike",
                  },
                  {
                    labelText: translate("traffic.vehicle.options.motorcycle.label", values),
                    labelIcon: <MotorcycleIcon />,
                    labelIconActive: <MotorcycleIcon active />,
                    value: "motorcycle",
                  },
                  {
                    labelText: translate("traffic.vehicle.options.truck.label", values),
                    labelIcon: <TruckIcon />,
                    labelIconActive: <TruckIcon active />,
                    value: "truck",
                  },
                  {
                    labelText: translate("traffic.vehicle.options.bus.label", values),
                    labelIcon: <BusIcon />,
                    labelIconActive: <BusIcon active />,
                    value: "bus",
                  },
                ]}
                validators={[requiredValidator("Bitte wählen Sie eine der angezeigten Antworten aus")]}
              />
            </Grid>
          </Grid>
          <FormSubmit {...submitProps} />
        </Box>
      </FormFader>
    </Paper>
  );
}
